import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const submitVendor = (payload) => api.post("/vendor", payload).then((r) => r.data);
export const CAPABILITY_PDF_URL = `${API}/capability-statement/pdf`;
